import { GalleryGrid } from '@/features/gallery/GalleryGrid'

export default function Gallery() {
  return (
    <div className="min-h-screen bg-cream-100">
      <div className="mx-auto max-w-7xl px-8 lg:px-16 pt-10 pb-16">
        <GalleryGrid />
      </div>

    </div>
  )
}
